var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 48.6,
    viewBox: "0 0 702 759",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M321.658 0H0V321.658C0 444.525 99.9583 544.483 222.821 544.483C232.692 544.483 242.396 543.771 251.929 542.521V430.454C242.638 432.942 232.883 434.288 222.821 434.288C160.721 434.288 110.2 383.763 110.2 321.658H321.658V0Z",
    fill: "#6180C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M380.146 222.825V544.483H591.604V758.033H701.8V222.825H380.146Z",
    fill: "#6180C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.209e93f054267d5ae58980861365d97e.svg";
export { ForwardRef as ReactComponent };